import { IPhysicalObject } from '../geometry';
export class Gravity {
private _gravity: number;
private _object: IPhysicalObject;
/**
 * @param {?} gravity
 * @param {?} obj
 */
constructor(gravity: number, obj: IPhysicalObject) {
    this._gravity = gravity;
    this._object = obj;
  }
/**
 * @return {?}
 */
public apply(): void {
    this._object.move(0, this._gravity);
  }
}

function Gravity_tsickle_Closure_declarations() {
/** @type {?} */
Gravity.prototype._gravity;
/** @type {?} */
Gravity.prototype._object;
}
